import axiosInstance from 'services/axiosMiddleware';

export async function getPranayamaReport(userID) {
  try {
    const response = await axiosInstance.post('pranayamma-report/get-Report', userID);

    return response.data;
  } catch (error) {
    console.error('Error fetching report data:', error);
    throw error;
  }
}

